export default __webpack_public_path__ + "static/media/onboarding-background-up.947d402d.svg";